module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gc-order-express-base', {
    attrs: {
      "express-detail": _vm.expressDetail
    },
    on: {
      "downloadExpressOutFile": _vm.downloadExpressOutFile1
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7074a85a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/emktcommon/orders/express/GcOrderExpressWithData.vue
// module id = 1673
// module chunks = 8